import {
  MobileResourceContent,
  MobileResourceFilterBar,
  MobileResourceFilterButton,
  MobileResourceFilterPicker,
  MobileResourceHeader,
  MobileResourceList,
  MobileResourceSearch,
  MobileResourceTitle,
  MobileResourceViewOptions,
  MobileResourceViewToggle,
} from './compound'
import { MobileResourceProvider } from './createMobileResourceProvider'

export type {
  MobileResourceConfig,
  MobileResourceRecordsResult,
} from './createMobileResourceProvider'

export const MobileResource = {
  Provider: MobileResourceProvider,
  Header: MobileResourceHeader,
  Title: MobileResourceTitle,
  ViewToggle: MobileResourceViewToggle,
  ViewOptions: MobileResourceViewOptions,
  Content: MobileResourceContent,
  FilterBar: MobileResourceFilterBar,
  Search: MobileResourceSearch,
  FilterButton: MobileResourceFilterButton,
  List: MobileResourceList,
  FilterPicker: MobileResourceFilterPicker,
}
